import { OnInit } from '@angular/core';
import { LoginService } from '../';
import { DateTimeConverstionService } from '../../services/index';
var AllcourseComponent = /** @class */ (function () {
    function AllcourseComponent(userService, timeZoneConverstionService) {
        this.userService = userService;
        this.timeZoneConverstionService = timeZoneConverstionService;
        this.subscriptions = [];
        this.onlinecourses = [];
        this.openCourses = [];
        this.openCoursesFilter = {};
        this.allduration = [];
        this.allprice = [];
        this.allcat = [];
        this.coursename = [];
        this.courseownername = [];
        this.searchdata = {};
        this.filtercoursekey = "";
        this.filtercoursename = "";
        this.timezone = 'UTC';
        this.msgTitle = "";
        this.msgContent = "";
        this.popUp = false;
    }
    AllcourseComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    AllcourseComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    AllcourseComponent.prototype.searchcourse = function (event) {
        var _this = this;
        var s1 = this.userService.courseNameAutocomplate(event.query).subscribe(function (data) {
            console.log(data);
            console.log('search auto complete');
            _this.coursename = data;
            var timezone = localStorage.getItem('timezone');
            console.log('search course');
            console.log(_this.openCourses);
            if (localStorage.getItem('timezone')) {
                _this.timezone = localStorage.getItem('timezone');
            }
            if (_this.timezone) {
                _this.timeZonechange(_this.timezone);
            }
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
        this.subscriptions.push(s1);
    };
    AllcourseComponent.prototype.clearFilter = function () {
        var _this = this;
        var s2 = this.userService.openCourses().subscribe(function (data) {
            console.log('claer filter');
            console.log(data);
            _this.openCourses = data;
            var timezone = localStorage.getItem('timezone');
            console.log('search course');
            console.log(_this.openCourses);
            if (localStorage.getItem('timezone')) {
                _this.timezone = localStorage.getItem('timezone');
            }
            if (_this.timezone) {
                _this.timeZonechange(_this.timezone);
            }
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
        this.subscriptions.push(s2);
    };
    AllcourseComponent.prototype.handleDropdownSelect = function (value) {
        var _this = this;
        console.log(value);
        this.searchdata.typeStr = "NameAndKeyWord";
        this.searchdata.courseName = value;
        this.searchdata.keyWords = this.filtercoursekey;
        var s3 = this.userService.searchCourse(this.searchdata).subscribe(function (data) {
            console.log('handle dropdownselect value');
            console.log(data);
            _this.openCourses = data;
            var timezone = localStorage.getItem('timezone');
            console.log('search course');
            console.log(_this.openCourses);
            if (localStorage.getItem('timezone')) {
                _this.timezone = localStorage.getItem('timezone');
            }
            if (_this.timezone) {
                _this.timeZonechange(_this.timezone);
            }
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
        this.subscriptions.push(s3);
    };
    AllcourseComponent.prototype.searchFilter = function () {
        var _this = this;
        this.searchdata.typeStr = "NameAndKeyWord";
        this.searchdata.courseName = this.filtercoursename;
        this.searchdata.keyWords = this.filtercoursekey;
        var s4 = this.userService.searchCourse(this.searchdata).subscribe(function (data) {
            console.log('search course');
            console.log(data);
            _this.openCourses = data;
            var timezone = localStorage.getItem('timezone');
            console.log('search course');
            console.log(_this.openCourses);
            if (localStorage.getItem('timezone')) {
                _this.timezone = localStorage.getItem('timezone');
            }
            if (_this.timezone) {
                _this.timeZonechange(_this.timezone);
            }
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
        this.subscriptions.push(s4);
    };
    AllcourseComponent.prototype.searchcourseowner = function (event) {
        var _this = this;
        var s5 = this.userService.courseownerNameAutocomplate(event.query).subscribe(function (data) {
            console.log(data);
            _this.courseownername = data;
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
        this.subscriptions.push(s5);
    };
    AllcourseComponent.prototype.handletutor = function (event) {
        var _this = this;
        this.searchdata.typeStr = "CourseByUser";
        var val = event.split(' ');
        if (val[0]) {
            this.searchdata.firstName = val[0];
        }
        else {
            this.searchdata.firstName = "";
        }
        if (val[1]) {
            this.searchdata.lastName = val[1];
        }
        else {
            this.searchdata.lastName = "";
        }
        var s6 = this.userService.searchCourse(this.searchdata).subscribe(function (data) {
            console.log(data);
            _this.openCourses = data;
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
        this.subscriptions.push(s6);
    };
    AllcourseComponent.prototype.ngOnInit = function () {
        var _this = this;
        var s7 = this.userService.openCourses().subscribe(function (data) {
            console.log(data);
            _this.openCourses = data;
            var timezone = localStorage.getItem('timezone');
            console.log('init');
            console.log(_this.openCourses);
            if (localStorage.getItem('timezone')) {
                _this.timezone = localStorage.getItem('timezone');
            }
            if (_this.timezone) {
                _this.timeZonechange(_this.timezone);
            }
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
        this.subscriptions.push(s7);
        var s8 = this.userService.openCoursesFilters().subscribe(function (data) {
            console.log(data);
            Object.keys(data.courseByPeriodMap).map(function (key) {
                _this.allduration.push(key);
            });
            Object.keys(data.courseByPriceMap).map(function (key) {
                _this.allprice.push(key);
            });
            Object.keys(data.courseByCategoryNameMap).map(function (key) {
                _this.allcat.push(key);
            });
            _this.openCoursesFilter = data;
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
        this.subscriptions.push(s8);
    };
    AllcourseComponent.prototype.durationFilter = function (value) {
        var _this = this;
        Object.keys(this.openCoursesFilter.courseByPeriodMap).map(function (key) {
            if (value == key) {
                _this.openCourses = _this.openCoursesFilter.courseByPeriodMap[key];
            }
        });
    };
    AllcourseComponent.prototype.priceFilter = function (value) {
        var _this = this;
        Object.keys(this.openCoursesFilter.courseByPriceMap).map(function (key) {
            if (value == key) {
                _this.openCourses = _this.openCoursesFilter.courseByPriceMap[key];
            }
        });
    };
    AllcourseComponent.prototype.catFilter = function (value) {
        var _this = this;
        Object.keys(this.openCoursesFilter.courseByCategoryNameMap).map(function (key) {
            if (value == key) {
                _this.openCourses = _this.openCoursesFilter.courseByCategoryNameMap[key];
            }
        });
    };
    AllcourseComponent.prototype.catallFilter = function () {
        var _this = this;
        var s9 = this.userService.openCourses().subscribe(function (data) {
            console.log(data);
            _this.openCourses = data;
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
        this.subscriptions.push(s9);
    };
    AllcourseComponent.prototype.registerClick = function (id) {
        localStorage.setItem('regcourse', id);
        alert("Please Login For Register Course.");
    };
    AllcourseComponent.prototype.timeZonechange = function (data) {
        var _this = this;
        console.log('timezone');
        this.openCourses.forEach(function (element) {
            element.displayStartDateOnlyConverted = _this.timeZoneConverstionService.convertTimezone(data, 'date', element.courseStartDTime);
            element.timeZoneConverted = data;
            element.displayStopDateOnlyConverted = _this.timeZoneConverstionService.convertTimezone(data, 'date', element.courseEndDTime);
            element.startTime.displayConverted = _this.timeZoneConverstionService.convertTimezone(data, 'time', element.courseStartDTime);
            element.endTime.displayConverted = _this.timeZoneConverstionService.convertTimezone(data, 'time', element.courseEndDTime);
        });
        localStorage.setItem('timezone', data);
    };
    return AllcourseComponent;
}());
export { AllcourseComponent };
//# sourceMappingURL=allcourse.component.js.map